module.exports = __webpack_public_path__ + "static/media/feature.b90f9f7b.jpg";